<template>
  <div class="scroll">
    <div class="calendar__wrap adminCalendar">
      <button
          class="calendar__btn"
          @click="prevPlaces"
          v-if="prevButton"
      >
        <img src="@/assets/images/icons/chevron-left-black.svg" alt="">
      </button>
      <button
          class="calendar__btn right"
          @click="nextPlaces"
          v-if="nextButton"
      >
        <img src="@/assets/images/icons/chevron-left-black.svg" alt="">
      </button>
      <FullCalendar
          ref="capi"
          :options="options"
      />
    </div>
  </div>

</template>

<script>
import FullCalendar from '@/calendar/vue/dist/main';
import interactionPlugin from '@/calendar/interaction';
import resourceTimeGridPlugin from '@/calendar/resource-timegrid';
import moment from "moment";

export default {
  name: "AdministratorCalendarComponent",
  components: {
    FullCalendar
  },
  props: {
    places: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentDate: null,
      offset: 0,
      api: null,
      options: {
        plugins: [interactionPlugin, resourceTimeGridPlugin],
        initialView: 'resourceTimeGridDay',
        editable: false,
        locale: 'ru',
        selectable: true,
        windowResize: this.resize,
        selectAllow: (e) => {
          return e.start > Date.now()
        },
        eventAdd: () => this.$emit('eventAdd'),
        eventClick: e => this.$emit('eventClick', e),
        select: e => this.$emit('select', e),
        unselect: e => this.$emit('unselect', e),
        headerToolbar: {
          start: '',
          end: ''
        },
        // businessHours: {
        //   startTime: '11:00', //время начала работы
        //   endTime: '17:00', //время конца работы
        // },
        width: 152,
        buttonText: {
          today: 'Сегодня'
        },
        titleFormat: {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        },
        height: 'auto',
        resources: [],
        slotLabelFormat: {
          hour: 'numeric',
          minute: '2-digit',
          omitZeroMinute: false,
          meridiem: 'short'
        },
        resourceAreaColumns: [
          {
            width: '152px'
          }
        ],
        selectOverlap: false,
        nowIndicator: true,
        displayEventTime: false,
        allDaySlot: false,
        slotMinTime: '09:00:00',
        slotMaxTime: '23:00:00'
      },
    }
  },
  computed: {
    prevButton() {
      return this.offset > 0
    },
    nextButton() {
      return this.offset + 7 < this.places.length
    }
  },
  watch: {
    'api.currentData.currentDate'(to, from) {
      this.currentDate = moment(to).format('YYYY-MM-DD');
      if (to !== from) this.loadRents();
    },
    offset(v) {
      this.options.resources = this.places.filter((_, idx) => {
        return idx >= v && idx < 7 + v
      })
    },
    places(v) {
      this.offset = 0
      this.options.resources = v.filter((_, idx) => {
        return idx >= this.offset && idx < 7 + this.offset
      })
    }
  },
  mounted() {
    this.api = this.$refs.capi.getApi()
    this.$emit('setApi', this.api)
    this.options.resources = this.places.filter((_, idx) => idx < 7)
    this.resize()

    this.$eventHub.$on('rent.changed', () => this.loadRents());
  },
  methods: {
    renderNewEvents(data) {
      if (this.api != null) {
        this.api.getEvents().forEach(event => event.remove());
        data.forEach(event => this.api.addEvent(event));
      }
    },
    loadRents() {
      this.$api.admin.rent.list({date: this.currentDate}).then(({data}) => this.renderNewEvents(data));
    },
    resize() {
      // if(window.innerWidth < 600){
      //   this.api.changeView('resourceTimeGridDay')
      // }else{
      //   this.api.changeView('timeGridWeek')
      // }
      this.$emit('mobile', window.innerWidth < 800)
    },
    today() {
      if (this.api != null) this.api.today();
    },
    next() {
      if (this.api != null) this.api.next();
    },
    prev() {
      if (this.api != null) this.api.prev();
    },
    addEvent(form) {
      this.api.addEvent({
        title: form.name,
        start: `${form.date}T${form.start}`,
        end: `${form.edate}T${form.end}`,
        resourceId: form.resId,
        working: false,
        dnc: false,
        payed: false,
        ended: false,
        id: Math.floor(Math.random() * 9999).toString()
      })
    },
    setStatus(id, propName, propValue = true) {
      let event = this.api.getEventById(id);
      event?.setExtendedProp(propName, propValue);
    },
    nextPlaces() {
      if (this.offset + 7 < this.places.length) {
        this.offset++
      }
    },
    prevPlaces() {
      if (this.offset > 0) {
        this.offset--
      }
    }
  },
  beforeDestroy() {
    this.$eventHub.$off('rent.changed');
  }

}
</script>

<style lang="scss">
.calendar__wrap {
  position: relative;
  min-width: 800px;
}

@media(max-width: 800px) {
  .scroll {
    overflow-y: auto;
  }
}

.calendar__btn {
  background-color: #E5E5E5;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.04), 0 2px 6px rgba(0, 0, 0, 0.04), 0 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  position: absolute;
  left: 30px;
  top: 300px;
  transform: rotateY(0);
  z-index: 599;

  &.right {
    right: 0;
    left: auto;
    transform: rotateY(180deg);
  }
}
</style>
<style lang="scss">
.adminCalendar {
  .fc {
    .fc-scroller-harness {
      overflow: visible;
    }

    .fc-scroller-liquid-absolute {
      overflow: visible !important;
    }
  }
}
</style>
